import React, { useEffect, useState } from 'react';
// Routes
import { NavLink, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  addCkStampConfig,
  clearsingedFile,
  selectFile,
  selectPdf,
  setDefaultPdfSign,
  setInputValues,
  setSingedFields,
  updateSelectedFileName,
  updateStamp
} from '../../Store/Redux/FileListSlice';
// Color
import { BLACK, GREEN, SALT_PAN, OCEAN_BLUE, TERTIARY_GREY, SUVA_GREY } from '../../Assets/Constants/theme';
// MUI
import {
  AppBar,
  Box,
  CssBaseline,
  Toolbar,
  Typography,
  Avatar,
  Grid,
  IconButton,
  Paper,
  useMediaQuery,
  Container
} from '@mui/material';
import { Logout, Settings } from '@mui/icons-material';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DrawIcon from '@mui/icons-material/Draw';

import PrimaryButton from '../Common/Button/PrimaryButton';
import { Stack } from '@mui/system';
// Image
import LeftArrow from '../../Assets/Images/LeftArrow.svg';
import EditButton from '../../Assets/Images/edit.svg';
import Logo from '../../Assets/Images/svgs/Logo.svg';
import Search from '../../Assets/Images/searchmobile.svg';
import Notification from '../../Assets/Images/notification.svg';
// Page
import BackWarningDialog from '../Common/BackWarningDialog';
import CreateNewTemplate from '../Pages/CKEditorComponent/CKEditorpopup/CreateNewTemplate';
import CKTemplatePopup from '../Pages/CKEditorComponent/CKEditorpopup/CKTemplatePopup';
import { useQueryParameters } from '../Common/useQueryParameters';
import {
  checkNotificationStatus,
  updateDigitalStampStatus,
  updateHiddenNotifications,
  updateEsignStatus,
  resetDashboard
} from '../../Store/DashboardSlice/DashboardSlice';
import { DeleteRefreshToken, GetBrand, GetProfilePic, userLogout } from '../../Services/APIConfig';
import { openWarning, resetAuth, updateStatus, updateUserInfo } from '../../Store/AuthSlice/AuthSlice';
import RenderMenu from '../Common/MenuDropdown/RenderMenu';
import { getErrorMessage, handleLogoutUtil } from '../../utils/util';
import { updateDocumentID, updateNewESignData } from '../../Store/Redux/NewESignSlice';
import { updateDigitalStampData, updateEstampData } from '../../Store/Redux/EstampSlice';
import { clearRecipient } from '../../Store/RecipientsSlice.js/RecipientsSlice';
import DigitalStampOrder from '../Common/DigitalStampOrderPopup/DigitalStampOrderPopup';
import NotificationIcon from '../../Assets/Images/notification.svg';
import NotificationDailog from '../Common/Dashboard/NotificationDailog';
import CustomToast from '../Common/CustomToast';
import Loading from '../Common/LoaderComponent/Loader';

const Header = ({ menuItems }) => {
  const { showToast } = CustomToast();
  const [searchParams, setSearchParams] = useSearchParams();
  const documentId = searchParams.get('documentId');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width:840px)');
  const { ckButton } = useSelector(state => state.ckeditor);
  const { holdTemplateName } = useSelector(state => state.fileList);
  const { notificationStatus, digitalStampOrderStatus, filteredData, esignStatus } = useSelector(
    state => state.dashboard
  );
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isWarningOpen, setWarningOpen] = useState(false);
  const [isCKTemplate, setIsCKTemplate] = useState(false);
  const [notifications, SetNotifications] = useState({ open: false });

  const [navItems, setNavItems] = useState([]);
  const { userInfo } = useSelector(state => state.auth);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [name, setName] = useState('');
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');
  const orgId = getParameter('orgId');
  const [openDigitalOrderPopup, setOpenDigitalOrderPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [profileImage, setProfileImage] = useState('');
  const [brandName, setBrandName] = useState(menuItems?.branding?.brandName);
  const [brandLogo, setBrandLogo] = useState(menuItems?.branding?.brandLogo);
  const [itemMenu, setItemMenu] = useState([
    {
      title: 'Profile',
      icon: AccountCircleIcon,
      onClick: () => navigate('/profile'),
      fontSize: 'small'
    },
    {
      title: 'Signature',
      icon: DrawIcon,
      onClick: () => navigate('/signature'),
      fontSize: 'small'
    },
    {
      title: 'Settings',
      icon: Settings,
      onClick: () => navigate('/setting'),
      fontSize: 'small'
    },
    {
      title: ' Change Password',
      icon: SyncLockIcon,
      onClick: () => handleResetPassword(),
      fontSize: 'small'
    },
    {
      title: 'Logout',
      icon: Logout,
      onClick: () => handleLogout(),
      fontSize: 'small'
    }
  ]);

  useEffect(() => {
    setBrandName(menuItems?.branding?.brandName);
    setBrandLogo(menuItems?.branding?.brandLogo);
  }, [menuItems?.branding?.brandName, menuItems?.branding?.brandLogo]);

  const handleResetPassword = () => {
    navigate('/reset-password-profile');
  };

  const handleClick = event => {
    if (location.pathname === '/new-esign' && documentId) {
      event.preventDefault();
      searchParams.append('approval', true);
      setSearchParams(searchParams);
      return;
    }

    if (
      location.pathname === '/recipient' ||
      location.pathname === '/stamp-form' ||
      location.pathname === '/edit' ||
      location.pathname === '/templatepreview'
    ) {
      event.preventDefault();
      dispatch(updateStatus({ value: true, data: { event: event, saveDraft: true } }));
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteRefreshToken = async () => {
    const response = await DeleteRefreshToken(localStorage.getItem('refreshToken'));
    if (response?.status === 200) {
      // console.log(response);
    }
  };

  useEffect(() => {
    if (userInfo?.profileImageChanged) {
      fetchProfilePic();
      dispatch(
        updateUserInfo({
          profileImageChanged: false
        })
      );
    }
  }, [userInfo?.profileImageChanged]);
  const fetchProfilePic = async () => {
    const response = await GetProfilePic();
    if (response?.status === 200) {
      setProfileImage(response?.result?.base64Image);
    }
  };
  useEffect(() => {
    let temp = [];
    if (userInfo?.menu) {
      let menuItem = Object.keys(userInfo?.menu);
      let tempTopMenu = menuItem.includes('Dashboard');
      if (tempTopMenu && Object.keys(userInfo?.menu?.Dashboard).includes('esign')) {
        let tempArr = userInfo?.menu?.Dashboard.esign;
        let isVisible = tempArr.some(val => val.permissionName == 'new_esign');
        isVisible && temp.push({ id: 1, title: '+ New e-Sign', color: GREEN, navigateTo: '/uploadfile' });
      }
      if (tempTopMenu && Object.keys(userInfo?.menu?.Dashboard).includes('bulk_esign')) {
        let tempArr = userInfo?.menu?.Dashboard.bulk_esign;
        let isVisible = tempArr.some(val => val.permissionName == 'bulk_new_esign');
        if (isVisible) {
          dispatch(updateEsignStatus(true));
        } else {
          dispatch(updateEsignStatus(false));
        }
        // isVisible && temp.push({ id: 3, title: 'Bulk e_sign', color: GREEN, navigateTo: '/bulk-esign' });
      }

      if (tempTopMenu && Object.keys(userInfo?.menu?.Dashboard).includes('digital_stamp')) {
        let tempArrOrg = userInfo?.menu?.Dashboard.digital_stamp;
        if (tempArrOrg.some(val => val.permissionName == 'digital_stamp_org_request')) {
          dispatch(updateDigitalStampStatus(true));
        } else {
          dispatch(updateDigitalStampStatus(false));
        }
      }
      temp.push({ id: 2, title: 'Notification', color: SALT_PAN, navigateTo: '' });
      temp.push({ id: 2, title: 'Profile', color: SALT_PAN, navigateTo: '/profile' });
      if (!menuItem.includes('Settings')) {
        let temp = itemMenu.filter(val => val.title != 'Setting');
        setItemMenu(temp);
      }
    } else {
      temp.push({ id: 2, title: 'Profile', color: SALT_PAN, navigateTo: '/profile' });
    }
    setNavItems(temp);

    if (userInfo?.userName) {
      formatHeaderName(userInfo?.userName);
    }

    // setProfileImage(userInfo?.userData?.profilePicPath);
  }, [userInfo]);
  function formatHeaderName(userName = '') {
    const splitWords = userName?.split(' ');
    const firstLetter = splitWords[0].charAt(0).toUpperCase();
    if (splitWords.length !== 1) {
      const lastLetter = splitWords[splitWords.length - 1].charAt(0).toLowerCase();
      setName(firstLetter + lastLetter);
    }
    setName(firstLetter);
  }

  const handleLogout = async () => {
		try {
			setIsLoading(true);
			dispatch(resetDashboard());
			const response = await userLogout();
			if (response?.status === 200) {
				handleLogoutUtil(dispatch, navigate);
			} else {
				showToast('error', getErrorMessage(response));
			}
		} catch (error) {
			showToast('error', getErrorMessage(error));
		} finally {
			setIsLoading(false);
		}
	};

  const handledUploadFileNavigate = () => {
    if (location.pathname !== '/uploadfile') {
      dispatch(selectFile(null));
      dispatch(setSingedFields([]));
      dispatch(selectPdf({}));
      dispatch(clearsingedFile([]));
    }

    if (orgId) {
      dispatch(selectFile(null));
      dispatch(setInputValues([]));
    }
    dispatch(updateNewESignData({ filename: '', reference: '' }));
    dispatch(updateDigitalStampData(null));
    dispatch(updateEstampData(null));
    dispatch(updateStamp(''));
    dispatch(clearRecipient([]));
    dispatch(updateDocumentID(null));
    dispatch(setDefaultPdfSign({ enabled: false }));

    navigate('/uploadfile');
  };

  const headerLogos = [{}];

  const handleNotificationStatus = () => {
    if (filteredData.length > 0) {
      dispatch(checkNotificationStatus(false));
      dispatch(updateHiddenNotifications([]));
    } else {
      showToast('error', 'There are no notifications');
    }
  };
  const handleBackBtn = () => {
    if (window.location.pathname !== '/templatepreview') {
      dispatch(openWarning());
    } else {
      navigate(-1);
    }
  };



  return (
    <>
    <Loading open={isLoading} />
      {isMobile ? (
        <>
          <RenderMenu
            anchorEl={anchorEl}
            open={open}
            handleClose={handleClose}
            handleLogout={handleLogout}
            handleResetPassword={handleResetPassword}
            itemMenu={itemMenu}
          />
          <Grid container sx={{ width: '100%' }}>
            <Paper
              elevation={0}
              sx={{ width: '100%', position: 'fixed', top: 0, left: 0, right: 0, bgcolor: '#FFF', zIndex: 99 }}
            >
              <Grid
                container
                justifyContent={'space-between'}
                alignItems='center'
                padding='14px'
                overflow={'auto'}
                flexWrap={'nowrap'}
                columnSpacing={2}
              >
                <Grid item>
                  <Stack direction={'row'} alignItems={'center'} columnGap={2}>
                    <NavLink
                      style={({ isActive }) => (isActive ? { stroke: TERTIARY_GREY } : { stroke: SUVA_GREY })}
                      to={'/statistics'}
                    >
                      <img style={{ verticalAlign: 'middle' }} src={Logo} alt='' />
                    </NavLink>
                    <Box>
                      {menuItems?.branding?.brandName ? (
                        <Box
                          className='medium4'
                          sx={{
                            display: 'flex',
                            width: '130px',
                            height: '40px',
                            backgroundColor: '#ECF0E5',
                            borderRadius: '5px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer'
                          }}
                        >
                          {brandName}
                        </Box>
                      ) : (
                        menuItems?.branding?.brandLogo && (
                          <Avatar
                            src={brandLogo || null}
                            className='avatar'
                            variant='square'
                            sx={{
                              width: '40px',
                              height: '40px',
                              border: '2px solid #B7D423',
                              position: 'relative'
                            }}
                          />
                        )
                      )}
                    </Box>
                  </Stack>
                </Grid>
                <Grid item>
                  <Stack direction={'row'} alignItems={'center'} columnGap={2}>
                    {headerLogos.map(val => (
                      <img key={val.id} style={{ verticalAlign: 'middle' }} src={val.image} alt='' />
                    ))}

                    {/* <IconButton onClick={() => SetNotifications({ open: true })}>
                      <Avatar
                        src={NotificationIcon}
                        style={{ color: 'black', cursor: 'pointer', height: '25px', width: '25px' }}
                      />
                    </IconButton> */}

                    <IconButton sx={{ p: 0 }}>
                      {profileImage ? (
                        <Avatar
                          src={profileImage || null}
                          className='avatar'
                          onClick={handleClick}
                          sx={{
                            width: '40px',
                            height: '40px',
                            border: '2px solid #B7D423',
                            position: 'relative'
                          }}
                        />
                      ) : (
                        <div
                          className='semiBold7'
                          onClick={handleClick}
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '20px',
                            border: '2px solid #B7D423',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'relative'
                          }}
                        >
                          {name}
                        </div>
                      )}
                    </IconButton>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
            {/* <NotificationDailog open={notifications.open} onClose={() => SetNotifications({ open: false })} /> */}
          </Grid>
        </>
      ) : (
        <Box sx={{ display: 'flex', width: { sm: '93%', lg: '95%' }, position: 'fixed', top: 0, zIndex: '99' }}>
          <CssBaseline />
          <AppBar
            // component='Grid'
            position='static'
            sx={{
              width: '100%',
              backgroundColor: '#fff',
              boxShadow: 0,
              borderBottom: '1px solid #ECF0E5'
            }}
          >
            <Toolbar style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {ckButton ? (
                <div
                  style={{
                    color: BLACK,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px'
                  }}
                >
                  <img src={LeftArrow} alt='' onClick={handleBackBtn} style={{ cursor: 'pointer' }} />

                  <div style={{ fontSize: '12px', display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ paddingRight: '10px' }}> {holdTemplateName}</Typography>
                    {createmode === 'true' && <img src={EditButton} onClick={() => setPopupOpen(true)} />}
                    <CKTemplatePopup open={isPopupOpen} onClose={() => setPopupOpen(!isPopupOpen)} type={'edit'} />
                  </div>
                </div>
              ) : (
                <Typography variant='h6' component='div' sx={{ flexGrow: 1, display: { color: '#21241E' } }}>
                  Hello, {userInfo?.userName}
                </Typography>
              )}

              <Box sx={{ display: 'flex', gap: 4 }}>
                {ckButton &&
                createmode === 'true' &&
                userInfo?.menu?.Template?.template_engine?.find(
                  item => item?.permissionName === 'template_engine_add'
                ) ? (
                  <PrimaryButton
                    value={'Create New Template'}
                    backgroundColor={GREEN}
                    borderRadius={'8px'}
                    fontWeight={400}
                    padding='10px 16px'
                    //marginRight={'32px'}
                    textcolor={'#000'}
                    onClick={() => setIsCKTemplate(true)}
                  />
                ) : null}
                {esignStatus && (
                  <PrimaryButton
                    className={'semiBold14'}
                    value={'Bulk e-Sign'}
                    backgroundColor={GREEN}
                    borderRadius={'8px'}
                    fontWeight={400}
                    padding='10px 16px'
                    textcolor={'#000'}
                    onClick={() => {
                      if (location.pathname === '/new-esign' && documentId) {
                        searchParams.append('approval', true);
                        setSearchParams(searchParams);
                      } else if (location.pathname === '/edit') {
                        dispatch(updateStatus({ value: true, data: { event: event, saveDraft: true } }));
                      } else {
                        navigate('/bulk-esign');
                      }
                    }}
                  />
                )}

                {digitalStampOrderStatus && (
                  <PrimaryButton
                    className={'semiBold14'}
                    value={'+ Digital Stamp Order'}
                    backgroundColor={GREEN}
                    borderRadius={'8px'}
                    fontWeight={400}
                    padding='10px 16px'
                    textcolor={'#000'}
                    onClick={() => {
                      if (location.pathname === '/new-esign' && documentId) {
                        searchParams.append('approval', true);
                        setSearchParams(searchParams);
                      } else if (location.pathname === '/edit') {
                        dispatch(updateStatus({ value: true, data: { event: event, saveDraft: true } }));
                      } else {
                        setOpenDigitalOrderPopup(true);
                      }
                    }}
                  />
                )}
                {isCKTemplate && <CreateNewTemplate open={isCKTemplate} onClose={() => setIsCKTemplate(false)} />}
                {navItems.map(item =>
                  item.title != 'Profile' && item.title !== 'Notification' ? (
                    <PrimaryButton
                      className={'semiBold14'}
                      value={item.title}
                      backgroundColor={item.color}
                      borderRadius={'8px'}
                      fontWeight={400}
                      padding='10px 16px'
                      key={item.id}
                      //marginRight={'32px'}
                      textcolor={'#000000'}
                      // onClick={
                      //   item.navigateTo === '/uploadfile' ? handledUploadFileNavigate : () => navigate(item.navigateTo)
                      // }
                      onClick={e => {
                        if (location.pathname === '/edit') {
                          dispatch(updateStatus({ value: true, data: { event: event, saveDraft: true } }));
                          return;
                        }
                        if (location.pathname === '/new-esign' && documentId) {
                          e.preventDefault();
                          searchParams.append('approval', true);
                          setSearchParams(searchParams);
                        }

                        if (item.navigateTo === '/uploadfile') {
                          if (location.pathname === '/new-esign' && documentId) {
                            e.preventDefault();
                            searchParams.append('approval', true);
                            setSearchParams(searchParams);
                          } else {
                            navigate('/new-esign');
                          }
                        } else {
                          navigate(item.navigateTo);
                        }
                      }}
                    />
                  ) : item.title === 'Notification' ? null : profileImage ? (
                    <Avatar
                      src={profileImage || null}
                      className='avatar'
                      onClick={handleClick}
                      sx={{
                        width: '40px',
                        height: '40px',
                        border: '2px solid #B7D423',
                        position: 'relative',
                        cursor: 'pointer'
                      }}
                      key={item.id}
                    />
                  ) : (
                    <div
                      className='semiBold7'
                      onClick={handleClick}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '20px',
                        border: '2px solid #B7D423',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'relative',
                        cursor: 'pointer'
                      }}
                      key={item.id}
                    >
                      {name}
                    </div>
                  )
                )}
                {/* <button
                  onClick={(e) => {
                     if (location.pathname === '/new-esign' && documentId) {
                       e.preventDefault();
                       searchParams.append('approval', true);
                       setSearchParams(searchParams);
                     }else{
                       navigate('/new-esign');
                     }
                  }}
                >
                  New Esign
                </button> */}
                <>
                  {menuItems?.branding?.brandName ? (
                    <Box
                      className='medium4'
                      sx={{
                        display: 'flex',
                        width: '130px',
                        height: '40px',
                        backgroundColor: '#ECF0E5',
                        borderRadius: '5px',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {brandName}
                    </Box>
                  ) : (
                    menuItems?.branding?.brandLogo && (
                      <Avatar
                        src={brandLogo || null}
                        className='avatar'
                        variant='square'
                        sx={{
                          width: '130px',
                          height: '40px',
                          position: 'relative'
                        }}
                      />
                    )
                  )}
                </>
              </Box>
              <RenderMenu
                anchorEl={anchorEl}
                open={open}
                handleClose={handleClose}
                handleLogout={handleLogout}
                handleResetPassword={handleResetPassword}
                itemMenu={itemMenu}
              />
            </Toolbar>
          </AppBar>
        </Box>
      )}
      {openDigitalOrderPopup && (
        <DigitalStampOrder open={openDigitalOrderPopup} onClose={() => setOpenDigitalOrderPopup(false)} />
      )}
    </>
  );
};

export default Header;
